import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SlotModel } from '../../../models/slot.model';
import { CandidateModel } from '../../../models/candidate.model';
import { GroupModel } from '../../../models/group.model';
import { DataService } from '../../../services/data.service';
import { AcStatusTimingsType, TimerType } from '../../../models/acstatus/ac-status.type';
import { Subscription } from 'rxjs';
import { UiService } from '../../../services/ui.service';

@Component({
  selector: 'app-controls-slot',
  templateUrl: './controls-slot.component.html',
  styleUrls: ['./controls-slot.component.scss']
})
export class ControlsSlotComponent implements OnInit, OnDestroy {

  @Input() slot: SlotModel = null;
  @Input() candidate: CandidateModel = null;
  @Input() group: GroupModel = null;
  @Input() mode: TimerType = TimerType.Exercise;

  public sending = false;

  private hash: string;
  private sendingSubscription: Subscription = null;

  constructor(
    private data: DataService,
    private ui: UiService
  ) { }

  ngOnInit(): void {
    this.hash = this.data.getHash(this.slot, this.candidate, this.group);
    this.sendingSubscription = this.data.sendingTiming$.subscribe((sending: boolean) => {
      this.sending = sending;
    });
  }

  ngOnDestroy(): void {
    if (this.sendingSubscription !== null) {
      this.sendingSubscription.unsubscribe();
      this.sendingSubscription = null;
    }
  }

  public isVisible(): boolean {
    return this.slot.ac?.isRunning() &&
      (
        this.slot?.exercise?.isSingleAc() ||
        this.slot?.exercise?.hasSettings() ||
        this.slot?.type === 'conference'
      );
  }

  public start(e: PointerEvent): void {
    e.stopImmediatePropagation();
    this.sendTiming(this.slot?.startSlot(this.hash, this.mode));
  }

  public pause(e: PointerEvent): void {
    e.stopImmediatePropagation();
    this.sendTiming(this.slot?.pauseSlot(this.hash, this.mode));
  }

  public resume(e: PointerEvent): void {
    e.stopImmediatePropagation();
    this.sendTiming(this.slot?.resumeSlot(this.hash, this.mode));
  }

  public finish(e: PointerEvent): void {
    e.stopImmediatePropagation();
    if (this.mode === TimerType.Rating && this.slot.messageBeforeFinish !== null) {
      this.ui.showConfirm(
        this.slot.messageBeforeFinish,
        null,
        () => {
          this.sendTiming(this.slot?.finishSlot(this.hash, this.mode));
        }
      );
    } else {
      this.sendTiming(this.slot?.finishSlot(this.hash, this.mode));
    }
  }

  public reset(e: PointerEvent): void {
    e.stopImmediatePropagation();
    this.sendTiming(null);
  }

  public isStopped(): boolean {
    return this.slot?.isStopped(this.hash, this.mode);
  }

  public isStartable(): boolean {
    return this.slot?.isStartable(this.hash, this.mode);
  }

  public isPauseable(): boolean {
    return this.slot?.isPauseable(this.hash, this.mode);
  }

  public isResumeable(): boolean {
    return this.slot?.isResumeable(this.hash, this.mode);
  }

  public isFinishable(): boolean {
    return this.slot?.isFinishable(this.hash, this.mode);
  }

  public isResetable(): boolean {
    return this.slot?.isResetable(this.hash, this.mode);
  }

  private sendTiming(timing: AcStatusTimingsType): void {
    this.data.setTiming(this.slot, this.hash, timing);
  }

}
